import { createSelector } from "reselect";
import getProfessionActiveCategoriesSelector from "./getProfessionActiveCategoriesSelector";

export default createSelector(
    getProfessionActiveCategoriesSelector,
    (_: Store, term_id: number) => term_id,
    (activeCategories, term_id) => activeCategories.includes(term_id)
);
